import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const CanEndiannessVisualizerGuidePage = () => <DataDrivenGuidePage slug="guide-can-endianness-visualizer" />;

export default CanEndiannessVisualizerGuidePage;
